<template>
  <div style="padding-bottom:1rem;">
    <div class="tabbar" ref="setHeightc">
      <van-tabs v-model="active">
        <van-tab v-for="(item,index) in swipeableList" :key="index">
          <div class="tab-title" slot="title" @click="choose(item)">{{ item.name }}</div>
          <hot :imge="item.bg" :cate="cate" :iosurl="ios_url" :url="url"></hot>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { cate } from "../../api/commonapi";
import secret from "../../assets/js/utils";
import hot from "./como/hot";
export default {
  components: {
    hot
  },
  data() {
    return {
      swipeableList: [],
      active: "",
      bg: "",
      cate: 0,
      ios_url: "",
      url: ""
    };
  },
  methods: {
    commHome() {
      cate({}).then(res => {
        res = res.data;
        let res_data = secret.Decrypt(res);
        let data = JSON.parse(res_data);
        if (data.code == 1) {
          this.swipeableList = data.data;
          this.bg = this.swipeableList[0].bg;
          this.ios_url = this.swipeableList[0].ios_url;
          this.url = this.swipeableList[0].url;
          console.log(this.ios_url);
          console.log(this.url);
          console.log(this.swipeableList);
          sessionStorage.setItem("list", JSON.stringify(data.data));
        }
      });
    },
    choose(item) {
      this.cate = item.id;
      this.bg = item.bg;
      this.ios_url = item.ios_url;
      this.url = item.url;
    }
  },
  watch: {
    active() {
      if (this.active !== "") {
        sessionStorage.setItem("active", JSON.stringify(this.active));
      }
    }
  },
  created() {
    this.commHome();
    if (JSON.parse(sessionStorage.getItem("list"))) {
      this.swipeableList = JSON.parse(sessionStorage.getItem("list"));
    } else {
      this.commHome();
    }
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.tabbar {
  // margin: auto;
  /deep/.van-tabs__wrap {
    width: 100%;
    position: fixed;
    background: #ffffff;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/community/community.vue